import { atomWithStorage } from 'jotai/utils';

export const CLAUSE_CAMPAIGNS_STORAGE_KEY = 'precifield.clauseCampaigns';
export const clauseCampaignsAtom = atomWithStorage<string[]>(
  CLAUSE_CAMPAIGNS_STORAGE_KEY,
  [],
);
